import { Pipe, PipeTransform } from '@angular/core';
import { ButtonLevels } from '@zipari/shared-ds-util-button';
import { LinkConfig } from '@zipari/shared-ds-util-navigation';
import { defaultStrings } from './sso-payment.constants';
import { SsoExternalConfig, SsoPaymentConfig } from './sso-payment.model';

@Pipe({
  name: 'externalSiteModalConfig',
})
export class ExternalConfigPipe implements PipeTransform {
  transform(config: SsoPaymentConfig): SsoExternalConfig {
    return {
      title: config.sso_modal_title,
      description: config.sso_disclaimer,
      footerCancelButton: config.sso_cancel,
      footerProceedButton: config.sso_proceed,
    };
  }
}

@Pipe({
  name: 'linkConfig',
})
export class LinkConfigPipe implements PipeTransform {
  transform(config: SsoPaymentConfig): LinkConfig {
    return {
      label: config.sso_cta_content,
      externalLink: config.sso_url,
      useExternalSiteModal: true,
      target: config.sso_target,
      button: {
        content: config.sso_cta_content || defaultStrings.continue,
        level: config.sso_cta_level || ButtonLevels.medium,
        icon: config.sso_cta_icon,
      },
    };
  }
}
